import { h, render } from "preact";
import ProductCardSwatches from "./product-card-swatches";
import QuickBuy from "./quick-buy";

class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.data = window.scrapeSectionData(this);
    this.swatchesContainer = this.querySelector("[data-swatches]");
    this.quickBuyContainer = this.querySelector("[data-quick-buy]");
    this.defaultMarkup = this.querySelector("[data-default-markup]").outerHTML;
    this.originalProductId = this.data.id;
    this.currentProductId = this.originalProductId;
    this.quickBuyRoot = null;

    this.addEventListener("product-card:update", (e) => {
      if (e.detail.product?.id !== this.currentProductId) {
        this.updateContent(e.detail.product);
      }

      // We need to clone the container to force Preact to re-render the quick buy
      // every time the product changes. Maybe integrating it with the swatches and using
      // a portal would be a better choice but 🤷
      const newQuickBuyContainer = this.quickBuyContainer.cloneNode();
      this.quickBuyContainer.replaceWith(newQuickBuyContainer);
      this.quickBuyContainer = newQuickBuyContainer;
      render(<QuickBuy product={e.detail.product} />, this.quickBuyContainer);
    });

    const hoverWrapper = this.querySelector(".product-card__hover-wrapper");

    hoverWrapper.addEventListener("mouseover", (e) => {
      // accessiBe tries to emulate mouseover events and breaks things.
      // Keyboard users should click through to image gallery on PDP.
      if (e instanceof CustomEvent) return;
      console.log("mouseover", e);
      this.classList.add("product-card--alternate-image");
    });

    hoverWrapper.addEventListener("mouseleave", (e) => {
      if (e instanceof CustomEvent) return;
      this.classList.remove("product-card--alternate-image");
    });

    this.addEventListener("mouseover", (e) => {
      if (e instanceof CustomEvent) return;
      this.classList.add("product-card--mouseover");
    });

    this.addEventListener("mouseleave", (e) => {
      if (e instanceof CustomEvent) return;
      this.classList.remove("product-card--mouseover");
      this.updateContent(null);
    });

    render(
      <ProductCardSwatches
        groupName={this.data.product_group}
        productId={this.originalProductId}
        cardEl={this}
      />,
      this.swatchesContainer
    );
  }

  updateContent(product) {
    if (!product) {
      return;
    }

    this.currentProductId = product.id;

    const targets = [
      {
        target: "title",
        replacer: (el) => {
          el.innerHTML = product.title;
        },
      },
      {
        target: "link",
        replacer: (el) => {
          el.href = product.helpers.url;
        },
      },
      {
        target: "fabricName",
        replacer: (el) => {
          el.innerHTML = product.fabricName?.value || "";
        },
      },
      {
        target: "imagePrimary",
        replacer: (el) => {
          const newUrl = product.media[0]?.previewImage.url;
          if (!newUrl) return;

          el.srcset = window.getSizedImageUrl(newUrl, "x800");
          el.parentNode
            .querySelectorAll("source")
            .forEach((source) => source.remove());
        },
      },
      {
        target: "imageSecondary",
        replacer: (el) => {
          const newUrl =
            product.media[1]?.previewImage.url ||
            product.media[0]?.previewImage.url;
          if (!newUrl) return;

          el.srcset = window.getSizedImageUrl(newUrl, "x800");
          el.parentNode
            .querySelectorAll("source")
            .forEach((source) => source.remove());
        },
      },
      {
        target: "price",
        replacer: (el) => {
          el.setAttribute("price", product.helpers.price);
          el.setAttribute("compare-at-price", product.helpers.compareAtPrice);
          el.setAttribute("currency", product.helpers.currency);
          el.setAttribute("dynamic", "");
        },
      },
      {
        target: "badge",
        replacer: (el) => {
          el.dispatchEvent(
            new CustomEvent("product-badge:update", { detail: { product } })
          );
        },
      },
      {
        target: "saleWarning",
        replacer: (el) => {
          el.style.display = product.tags.includes("Final Sale")
            ? null
            : "none";
        },
      },
    ];

    targets.forEach(({ target, replacer }) => {
      const el = this.querySelector(`[product-data-target="${target}"]`);

      if (el) {
        replacer(el);
      }
    });
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
